/* ============================================================
   DEV-3835 Advertorial sticky bar
   Reveals the sticky mobile bar once the visitor has scrolled past a
   configurable percentage of the page, and flags the body so the page
   reserves bottom space for the bar on mobile. Self-contained, no theme
   dependencies.
   ============================================================ */
(function () {
  'use strict';

  var bars = document.querySelectorAll('.sc-sticky-bar');
  if (!bars.length) {
    return;
  }

  // Reserve mobile bottom space so the bar never hides the last content.
  document.body.classList.add('sc-advertorial-template');

  var ticking = false;

  function update() {
    ticking = false;

    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    var percent = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 100;

    for (var i = 0; i < bars.length; i++) {
      var threshold = parseFloat(bars[i].getAttribute('data-reveal-at')) || 30;
      bars[i].classList.toggle('is-visible', percent >= threshold);
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
